__turbopack_context__.v({
  "ReusableText": "RichtextSection-module-scss-module__lVBXUa__ReusableText",
});
